import React from "react";

export type SaveCallback = () => boolean | Promise<boolean> | void | Promise<void> | undefined;

export interface PreventNavigationProps {
    navigationPrevented: boolean;
    setIsNavigationPrevented: (processing: boolean) => void;
    
    hasSaveCallback: boolean;
    callSaveCallback: () => Promise<boolean>;
    setSaveCallback: (callback?: SaveCallback) => void;
}

export const PreventNavigationContext = React.createContext<PreventNavigationProps | undefined>(undefined);